import { k, useCss } from 'kremling'
import React from 'react'

import { TextInput } from '@components/mantine/text-input.component'
import { RichText } from '@components/rich-text/rich-text.component'
import { useAppState } from '@src/app.state'
import { useParams } from 'react-router-dom'

type FieldDescriptionProps = {
  field: Field
  onChange: (field: Field, debounce?: boolean) => void
}

export function FieldDescription({ field, onChange }: FieldDescriptionProps) {
  const scope = useCss(css)
  const { orgId } = useParams()

  function updateFieldValue(value: string) {
    const updatedField = {
      ...field,
      value,
    }
    onChange(updatedField)
  }

  function updateFieldLabel(value: string) {
    if (value === field.label) return
    const updatedField = {
      ...field,
      label: value,
    }
    onChange(updatedField, true)
  }

  return (
    <div {...scope}>
      <div className="form-group">
        <TextInput
          label="Description title"
          defaultValue={field.label}
          onChange={updateFieldLabel}
          placeholder="Type here..."
          autoFocus
        />
      </div>
      <div className="form-group">
        <label htmlFor="text-field-desc">
          Provide some descriptive text for your user to read
        </label>
        <RichText
          id="text-field-desc"
          onChange={updateFieldValue}
          initialValue={field ? field.value : null}
          placeholder="Type here..."
          uploadOptions={{
            user: useAppState.getState().user,
            orgId,
          }}
        />
      </div>
    </div>
  )
}

const css = k`

`
